import { comparisonData } from "@/mocks/categories";

export default function WhatIsSection() {
  return (
    <section id="what-is" className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            Learn More
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            What Is Sugargoo Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Sugargoo Spreadsheet is a structured product research database that helps shoppers discover popular products, compare options, review quality information, and make smarter purchasing decisions through Sugargoo.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70 bg-background-50">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/70 bg-secondary-50">
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-600 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-search-line text-foreground-400"></i>
                    Manual Search
                  </span>
                </th>
                <th className="text-left px-5 py-4 font-semibold text-primary-600 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-database-2-line"></i>
                    Sugargoo Spreadsheet
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={idx} className={`border-b border-background-200/50 ${idx % 2 === 0 ? "bg-background-50" : "bg-secondary-50/50"}`}>
                  <td className="px-5 py-3.5 font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{row.manual}</td>
                  <td className="px-5 py-3.5 text-foreground-800 font-medium">{row.spreadsheet}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}